import { ISchema, PaywallComponentProps } from '../../@types'
import { mergeDeep } from '@/helpers/utils'

// web_auto_checkout (activity-male-chair-tai-chi):
// PaywallPlanPicker defaults to a single intersection threshold of 1, which isn't enough to
// reliably emit planPickerVisible. Override it with lower thresholds [0, 0.5, 0.7, 1] (like
// PaywallPlanPickerComp) so the auto-checkout trigger fires once the picker is fully seen.
export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				autoCheckout: true,
			},
			components: {
				PaywallPlanPicker: ({ $t }): PaywallComponentProps.PlanPicker => ({
					intersectionOptions: {
						rootMargin: '0px',
						threshold: [0, 0.5, 0.7, 1],
					},
					items: [
						{
							title: $t('pages.program.cheap_and_short.plans.7_days.period_text'),
							subtitleType: 'strikethrough-original-price',
							rightPriceType: 'per-day',
						},
						{
							title: $t('pages.program.cheap_and_short.plans.30_days.period_text'),
							subtitleType: 'strikethrough-original-price',
							rightPriceType: 'per-day',
							badge: {
								theme: 'right',
								text: $t('pages.program.cheap_and_short.common.planPicker.mostPopular'),
								uppercase: true,
							},
						},
						{
							title: $t('pages.program.cheap_and_short.plans.90_days.period_text'),
							subtitleType: 'strikethrough-original-price',
							rightPriceType: 'per-day',
						},
					],
				}),
			},
		},
	)
